import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const get = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_PROVIDER_KEY_LIST_W_DATES_REQUEST });

  return api.app.providerKeyListWDates.get(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PROVIDER_KEY_LIST_W_DATES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PROVIDER_KEY_LIST_W_DATES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
export const getDistinct = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_REQUEST });

  return api.app.providerKeyListWDates.getDistinct(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DISTINCT_PROVIDER_KEY_LIST_W_DATES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  
